import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {LabelSmall} from "@khanacademy/wonder-blocks-typography";

interface LoadingProps {
    cardWidth: number;
    cardHeight: number;
}

const LoadingCard: React.FC<LoadingProps> = (props) => {
    const cardDimensions = {
        width: props.cardWidth,
        height: props.cardHeight,
    };
    return (
        <View style={[styles.loadingCard, cardDimensions]}>
            <Strut size={spacing.xLarge_32} />
            <LabelSmall>{t`Generating questions...`}</LabelSmall>
            <Strut size={spacing.large_24} />
            <CircularSpinner size="medium" />
            <Strut size={spacing.large_24} />
        </View>
    );
};

const styles = StyleSheet.create({
    loadingCard: {
        alignItems: "center",
        overflow: "hidden",
        display: "flex",
        position: "absolute",
        backgroundColor: "inherit",
    },
});

export default LoadingCard;
